import React from 'react';
import './App.css';
import Layout from './views/layout/Layout';

function App (props) {
  return <Layout {...props} />;
}

export default App;
